import { useState } from "react";
import { Youtube, Play } from "lucide-react";

// Latest 6 uploads from @TastebudsAnu (channel UCrC6mxhGslaTZnJDiVAOKiA).
// Sourced from the channel's public RSS feed. YouTube's feed is CORS-blocked for
// browser fetches, so this list is a snapshot — refresh it to pull newer uploads.
const VIDEOS = [
  { id: "fymmLOj6CXo", title: "Simply South | Dallas Indian Restaurants" },
  { id: "B3991uv5UXc", title: "The Monks, Lewisville | Dallas Indian Restaurants" },
  { id: "F3jGFf1oSjM", title: "The Monks Lewisville | Dallas Indo Chinese Restaurant" },
  { id: "Vyjjw_aHIFY", title: "Coco Mango" },
  { id: "dpMapxGtii4", title: "Hyderabad House Irving | Dallas Indian Restaurants" },
  { id: "fUNxQZe0VLw", title: "Raju Gari Bhojanam, Hyderabad House Irving" },
];

export default function YouTubeWidget() {
  const [playingId, setPlayingId] = useState<string | null>(null);

  return (
    <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm bg-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100">
        <div className="w-6 h-6 rounded-full bg-red-600 flex items-center justify-center shrink-0">
          <Youtube className="w-3.5 h-3.5 text-white" />
        </div>
        <span className="text-[13px] font-semibold text-gray-800">@TastebudsAnu</span>
        <span className="ml-auto text-[11px] text-gray-400">Latest videos</span>
      </div>

      <div className="p-3 grid grid-cols-2 gap-2.5">
        {VIDEOS.map((v) => (
          <div key={v.id} className="flex flex-col">
            <div className="relative w-full rounded-lg overflow-hidden bg-black" style={{ aspectRatio: "16 / 9" }}>
              {playingId === v.id ? (
                <iframe
                  src={`https://www.youtube.com/embed/${v.id}?autoplay=1`}
                  className="absolute inset-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title={v.title}
                />
              ) : (
                <button
                  type="button"
                  onClick={() => setPlayingId(v.id)}
                  className="absolute inset-0 w-full h-full group"
                  aria-label={`Play ${v.title}`}
                >
                  <img
                    src={`https://img.youtube.com/vi/${v.id}/mqdefault.jpg`}
                    alt={v.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <span className="absolute inset-0 bg-black/5 group-hover:bg-black/20 transition-colors" />
                  <span className="absolute bottom-1.5 right-1.5 w-6 h-6 rounded-full bg-red-600/90 flex items-center justify-center shadow-sm">
                    <Play className="w-3 h-3 text-white fill-white ml-[1px]" />
                  </span>
                </button>
              )}
            </div>
            <p className="text-[11px] text-gray-700 leading-snug mt-1.5 line-clamp-2">{v.title}</p>
          </div>
        ))}
      </div>

      <div className="px-4 py-3 border-t border-gray-100 flex justify-center">
        <a
          href="https://www.youtube.com/@TastebudsAnu"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-5 py-2.5 rounded-full text-white text-sm font-semibold transition-transform hover:scale-105 active:scale-95"
          style={{ background: "#ff0000" }}
        >
          <Youtube className="w-4 h-4" />
          Subscribe on YouTube
        </a>
      </div>
    </div>
  );
}
